/*=============================
=    Testimonials Load More   =
=============================*/

var loadMore = document.querySelector('#load-more-testimonials'),
	testimonialsContainer = document.querySelector('#testimonials-others .testimonials-container'),
	currentPage = 2;

if(!testimonialsContainer.querySelectorAll('.video-container').length)
	document.getElementById('testimonials-others').style.paddingTop = 0;

if(loadMore) {
	loadMore.addEventListener('click', function() {
		loadMore.setAttribute('disabled', true);

		testimonialsContainer.style.minHeight = testimonialsContainer.offsetHeight+'px';

		axios.post('/testimonials-load', {page: ++currentPage})
		.then(function(r) {
			if(r.data.testimonials) {
				testimonialsContainer.innerHTML+= r.data.testimonials;
				Velocity(testimonialsContainer, 'slideDown', {duration: 500});
				loadMore.removeAttribute('disabled');

				if(r.data.last)
					loadMore.style.display = 'none';
			}
		})
		.catch(function (e) {
			console.log(e);
		});
	});
}

var Observer = new MutationObserver(function(mutations) {
	mutations.forEach(function(mutation) {
		for(var i = 0; i < mutation.addedNodes.length; i++) {
			var videoButton = mutation.addedNodes[i].querySelector('button');

			if(videoButton)
				videoButton.addEventListener('click', videoButtonClick);
		}
	});
});

Observer.observe(testimonialsContainer, {
	childList: true,
	subtree: true
});